import isEmail from "validator/lib/isEmail";

export default {
  required: [(v) => !!v || "Pakollinen kenttä"],
  positiveNumber: [(v) => checkPositiveNumber(v) || "Anna positiivinen luku"],
  negativeNumber: [(v) => checkNegativeNumber(v) || "Anna negatiivinen luku"],
  emptyOrPositiveNumber: [
    (v) => checkEmptyOrPositiveNumber(v) || "Anna positiivinen luku tai jätä tyhjäksi",
  ],
  zeroOrGreater: [(v) => checkZeroOrGreater(v) || "Anna luku, joka on 0 tai suurempi"],
  requiredArray: [(v) => checkArrayLength(v) || "Valitse vähintään yksi"],
  requiredBooleanVal: [(v) => checkRequiredBoolean(v) || "Valitse jokin arvo"],
  anyNumber: [(v) => validateNumber(v) || "Valitse jokin arvo"],
  numberBetween: validateNumberBetween,
  email: [(v) => isEmail(String(v)) || "Email ei ole oikeassa muodossa"],
  email2: [(v) => testEmail(v)],
  responsive: [(v) => validateResponsivenes(v)],
  colPadding: [(v) => validateColPadding(v)],

  isValidEmail(v) {
    if (!v) {
      return false;
    }
    return isEmail(String(v));
  },

  isValidReplyToEmail(v) {
    if (v === null) {
      return true;
    }
    return isEmail(String(v));
  },

  maxNumber(baseNum) {
    return (num) => {
      return num <= baseNum || "Liian suuri arvo";
    };
  },

  arrayMaxLength(num) {
    return (arr) => {
      return arr.length <= num || "Liian monta arvoa valittu";
    };
  },

  validateGovid(value) {
    // Jos value on tyhjä, ei tehdä mitään tarkistuksia ja palautetaan null
    if (!value) return null;
    const checksumChars = "0123456789ABCDEFHJKLMNPRSTUVWXY";

    const hetuRegex = new RegExp(`^([0-9]{6})(.)([0-9]{3})([${checksumChars}])$`);
    const match = value.match(hetuRegex);

    // Jos match palauttaa null, palautetaan virheilmoitus
    if (!match) return "Henkilötunnus on väärässä muodossa.";

    // Puretaan matchin tulokset
    const [, ddmm, centuryChar, individualNum, checksumChar] = match;

    // Tarkistetaan vuosisatamerkki
    const validCenturyChars = "+-ABCDEFYXWVU"; // Sallitut vuosisatamerkit

    if (!validCenturyChars.includes(centuryChar)) {
      return "Virheellinen vuosisatamerkki.";
    }

    // Puretaan päivämäärä ja juokseva numero
    const dd = ddmm.substring(0, 2);
    const mm = ddmm.substring(2, 4);
    const yy = ddmm.substring(4, 6);

    // 1. Vuosisatamerkki tarkistus
    const fullYear =
      (centuryChar === "+"
        ? 1800
        : "-YXWVU".includes(centuryChar)
        ? 1900
        : "ABCDEF".includes(centuryChar)
        ? 2000
        : null) + parseInt(yy, 10);

    // Lasketaan syntymäpäivämäärä
    const day = parseInt(dd, 10);
    const month = parseInt(mm, 10);
    const birthDate = new Date(fullYear, month - 1, day);

    // Tarkistetaan, että syntymäpäivämäärä ei ole tulevaisuudessa
    const currentDate = new Date();
    if (birthDate > currentDate) {
      return "Henkilö ei voi olla syntynyt tulevaisuudessa.";
    }

    // Tarkistetaan, että kuukausi on välillä 1–12
    if (month < 1 || month > 12) {
      return "Virheellinen kuukausi.";
    }

    // Tarkistetaan, että päivä on validi tietylle kuukaudelle ja vuodelle
    const isLeapYear = (year) => {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    };

    // Tarkistetaan, että päivä on validi ottaen huomioon kuukauden päivät ja karkausvuodet
    const daysInMonth = [
      31,
      isLeapYear(fullYear) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ];

    if (day < 1 || day > daysInMonth[month - 1]) {
      return "Virheellinen päivämäärä.";
    }

    // 2. Juoksevan numeron tarkistus (002-899)
    const individualNumParsed = parseInt(individualNum, 10);
    if (individualNumParsed < 2 || individualNumParsed > 899) {
      return "Virheellinen juokseva numero.";
    }

    // 3. Tarkistusmerkin tarkistus
    const checksumBase = `${dd}${mm}${yy}${individualNum}`;
    const checksumIndex = parseInt(checksumBase, 10) % 31;
    const expectedChecksum = checksumChars[checksumIndex];

    if (expectedChecksum !== checksumChar) {
      // Tarkistusmerkin on viimeinen merkki
      return `Virheellinen tarkistusmerkki, mikäli numerot ovat oikein, odotettiin: ${expectedChecksum}`;
    }

    return null;
  },
};

function validateNumber(v) {
  if (v === null || v === "") {
    return false;
  }
  const numberValue = parseFloat(v);
  if (isNaN(numberValue)) {
    return false;
  }
  return true;
}

function validateNumberBetween(obj) {
  const max = obj.max;
  const min = obj.min;

  return (v) => {
    if (v === null || v === "") return "Valitse numero";

    const numberValue = parseFloat(v);
    if (isNaN(numberValue)) return "Valitse numero";

    if (v >= min && v <= max) return true;
    else return `Numero ei ole halutulta väliltä ${min}-${max}`;
  };
}

function checkPositiveNumber(v) {
  if (v > 0 || v == "") return true;
  else return false;
}

function checkNegativeNumber(v) {
  if (v < 0 || v == "") return true;
  else return false;
}

function checkZeroOrGreater(v) {
  if (v < 0 || v === "" || v === null) return false;
  else return true;
}

function checkEmptyOrPositiveNumber(val) {
  if (!val) {
    return true;
  }
  return val > 0 || "Anna positiviinen luku";
}

function testEmail(v) {
  if (!v) {
    return true;
  }
  return isEmail(String(v)) || "Email ei ole oikeassa muodossa";
}

function validateResponsivenes(value) {
  const pattern = /^(\d+\s){0,4}\d+$/;
  const numbers = value.split(" ").map(Number);
  if (!pattern.test(value)) {
    return false;
  }
  if (numbers.some((num) => num < 1 || num > 12)) {
    return false;
  }
  if (numbers.length < 1 || numbers.length > 5) {
    return false;
  }
  return true;
}

function validateColPadding(value) {
  if (value === "" || !value) return true;

  const pattern = /^(\d+\s){0,3}\d+$/;
  const numbers = value.split(" ").map(Number);
  if (!pattern.test(value)) {
    return false;
  }
  if (numbers.some((num) => num < 0 || num > 16)) {
    return false;
  }
  if (numbers.length > 4) {
    return false;
  }
  return true;
}

function checkArrayLength(value) {
  if (!value) return false;
  if (typeof value == "object" && Array.isArray(value)) {
    return value.length > 0 ? true : false;
  }
}

function checkRequiredBoolean(value) {
  if (typeof value === "boolean") return true;
  else return false;
}
